import React from "react";
import {forms} from "../forms";
import {MtplPackageSelectForm} from "../forms/PackageSelect/MtplPackageSelectForm";
import {StepProps} from "../step-props";
import {ErrorMessageDialog} from "../../../components/dialogs/ErrorMessageDialog";
import {useTariffication} from "./hooks/useTariffication";
import {ErrorDialogType, useErrorDialog} from "../../../utils/hooks/useErrorDialog";
import {MtplScenarioHeader} from "../forms/MtplScenarioHeader";

export const MtplTarifficationStep = ({step}: StepProps) => {
    const {
        textErrorMessageDialog, setTextErrorMessageDialog,
        openErrorMessageDialog, setOpenErrorMessageDialog,
        textDetailErrorMessageDialog, setTextDetailErrorMessageDialog
    } = useErrorDialog();

    const {
        tariffied,
        packages,
        onPackageSelect,
        onRecalculate,
        onFormSubmit
    } = useTariffication("mtpl_online_00001", setTextErrorMessageDialog, setTextDetailErrorMessageDialog, setOpenErrorMessageDialog);

    return (
        <>
            <MtplScenarioHeader/>

            {tariffied && (
                <MtplPackageSelectForm packages={packages}
                                       onPackageSelect={onPackageSelect}
                                       onBackStep={onRecalculate}/>
            )}

            {!tariffied && (
                step.forms.map(form => {
                    return React.createElement(forms[form.code], {
                        key: form.code,
                        onFormSubmit,
                        setOpenErrorMessageDialog,
                        setTextErrorMessageDialog
                    })
                })
            )}
            <ErrorMessageDialog type={ErrorDialogType.ERROR}
                                text={textErrorMessageDialog}
                                open={openErrorMessageDialog}
                                onClickListener={() => setOpenErrorMessageDialog(false)}
                                textDetail={textDetailErrorMessageDialog}/>
        </>
    );
};